import {
  usePlaylistDetailsQuery,
  usePlaylistTracksQuery,
} from "@queries/playlistQueries";
import { IPlaylistRecord } from "@src/types/playlist";
import { ITrack } from "@src/types/track";

// interface UsePlaylistsResult {
//     playlists: IPlaylistRecord[];
//     isLoading: boolean;
//     error: any;
//     refetchPlaylists: () => void;
// }

interface UsePlaylistTracksResult {
  tracks: ITrack[];
  isLoading: boolean;
  error: any;
  refetch: () => void;
}
interface UsePlaylistDetailsResult {
  playlist: IPlaylistRecord | null;
  isLoading: boolean;
  error: any;
  refetch: () => void;
  isFetching: boolean;
}

export const usePlaylistTracks = (
  playlistId: string,
  filters: { searchText: string }
): UsePlaylistTracksResult => {
  const { data, isLoading, error, refetch } = usePlaylistTracksQuery(
    playlistId,
    filters
  );
  return {
    tracks: data?.data?.data || [],
    isLoading,
    error,
    refetch,
  };
};

export const usePlaylistDetails = (
  playlistId: string
): UsePlaylistDetailsResult => {
  const { data, isLoading, error, refetch, isFetching } =
    usePlaylistDetailsQuery(playlistId);
  return {
    playlist: data?.data?.data || null,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};
